import { Component, OnInit} from '@angular/core';
import {
    SalesConciergeCustomContactInfo,
    SalesConciergeCustomerInfo,
    SalesConciergeRequest
} from '../../models/sales-concierge-request.model';
import {SalesConciergeRequestType} from '../../enums/sales-concierge-request-type.enum';
import {SalesConciergeStep} from '../../enums/sales-concierge-step.enum';
import {ISalesConciergeHttpService} from '../../services/sales-concierge.service.interface';
import {SalesConciergeContactType} from '../../enums/sales-concierge-contact-type.enum';
import {SalesConciergeProductCount} from '../../enums/sales-concierge-product-count.enum';
import {ToastService} from '../../../../../../../shared/services/toast.service';
import {ModalDialogV3} from '../../../../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
    selector: 'app-sales-concierge-modal-dynamic',
    templateUrl: './sales-concierge-modal-dynamic.component.html',
    styleUrl: './sales-concierge-modal-dynamic.component.scss'
})
export class SalesConciergeModalDynamicComponent extends ModalDialogV3 implements OnInit {
    public salesConciergeRequest: SalesConciergeRequest;
    public showRequestType = true;
    public showProductCountInfo = false;
    public showCustomerInfo = false;
    public showCustomerContactInfo = false;
    public isValid = false;
    public resetEnabled = false;
    public salesConciergeRequestType = SalesConciergeRequestType;
    public salesConciergeNextStep: SalesConciergeStep;


    public constructor(
        private toastService: ToastService,
        private salesConciergeService: ISalesConciergeHttpService,
    ) {
        super();
    }

    public getKeyByValue(EnumType: Object, value: any): string {
        return Object.keys(EnumType).find(key => EnumType[key] === value);
    }

    public ngOnInit() {
        this.resetAll();
        this.hideAllSteps();
        this.showRequestType = true;
    }


    public closeOnlyAndNotifyClient(): void {

        const close = 'CLOSE';

        // post a message to close the NATIVE modal view
        this.postIosMessage({
            action: close
        });

        this.postAndroidMessage(close);

        this.close();
    }

    public close(): void {
        super.close();
    }

    private postIosMessage(messageArgs: any): void {
        if (window.webkit) {
            window.webkit.messageHandlers.iosMessageHandler.postMessage(messageArgs);
        }
    }

    private postAndroidMessage(message: string): void {
        try {
            if (android) {
                android.postMessage(message);
            }
        } catch {

        }
    }


    private resetAll() {
        this.salesConciergeNextStep = null;
        this.salesConciergeRequest = new SalesConciergeRequest();
        this.salesConciergeRequest.requestType = null;
        this.salesConciergeRequest.contactType = null;
        this.salesConciergeRequest.customContactInfo = null;
        this.salesConciergeRequest.customerInfo = null;
        this.salesConciergeRequest.otherIssuesMessage = null;
        this.salesConciergeRequest.productCountInfo = null;
        this.salesConciergeRequest.requestNotes = null;
    }

    public setRequestNextStep(step: SalesConciergeStep) {
        this.salesConciergeNextStep = step;
    }

    public isEmailValid(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    public setRequestSteps(request: SalesConciergeRequest) {

        this.salesConciergeRequest = request;
        this.isValid = false;
        this.resetEnabled = false;

        // console.log(request);

        switch (SalesConciergeRequestType[this.salesConciergeRequest.requestType]) {
            case this.salesConciergeRequestType.OTHER_ISSUES:
                if (request.otherIssuesMessage !== undefined && request.otherIssuesMessage !== 'undefined' && request.otherIssuesMessage !== null && request.otherIssuesMessage.length > 0) {
                    this.isValid = true;
                }
                this.resetEnabled = true;
                break;
            case this.salesConciergeRequestType.DEALER_CONTRACT_OR_BILLING_ISSUES:
                this.isValid = true;
                this.resetEnabled = true;
                break;
            case this.salesConciergeRequestType.NEW_ACQUISITION:
                this.isValid = true;
                this.resetEnabled = true;

                if (this.showCustomerInfo) {
                    this.isValid = false;
                    this.resetEnabled = false;
                    if (this.salesConciergeRequest.customerInfo.customerType !== null && this.salesConciergeRequest.customerInfo.zip !== null && this.salesConciergeRequest.customerInfo.zip.toString().length > 3 && this.salesConciergeRequest.customerInfo.zip.toString().length < 6) {
                        this.isValid = true;
                    }

                    if (this.salesConciergeRequest.customerInfo.customerType !== null || this.salesConciergeRequest.customerInfo.zip !== null) {
                        this.resetEnabled = true;
                    }
                }
                break;
            case this.salesConciergeRequestType.NO_INFORMATION:
                this.isValid = true;
                this.resetEnabled = true;
                break;
            case this.salesConciergeRequestType.TECHNICAL_ISSUE_OR_SUPPORT:
                this.isValid = true;
                this.resetEnabled = true;
                break;
        }

        if (this.showCustomerContactInfo && SalesConciergeContactType[this.salesConciergeRequest.contactType] === SalesConciergeContactType.EXISTING_CONTACT_INFO) {
            this.salesConciergeRequest.customContactInfo = new SalesConciergeCustomContactInfo();
            this.salesConciergeRequest.customContactInfo.email = null;
            this.salesConciergeRequest.customContactInfo.name = null;
            this.salesConciergeRequest.customContactInfo.phone = null;
        }


        if (this.showCustomerContactInfo && SalesConciergeContactType[this.salesConciergeRequest.contactType] === SalesConciergeContactType.CUSTOM_CONTACT_INFO) {
            this.isValid = (this.salesConciergeRequest.customContactInfo !== null && this.salesConciergeRequest.customContactInfo !== undefined) &&
                (this.isEmailValid(this.salesConciergeRequest.customContactInfo.email) && this.salesConciergeRequest.customContactInfo.name !== null);
        }


    }

    public onPreviousClick(currentStep: SalesConciergeStep) {


        this.hideAllSteps();
        this.isValid = true;
        this.resetEnabled = true;
        switch (currentStep) {
            case SalesConciergeStep.REQUEST_TYPE:
                this.showRequestType = true;
                break;
            case SalesConciergeStep.PRODUCT_COUNT_INFO:
                this.showProductCountInfo = true;
                break;
            case SalesConciergeStep.CUSTOMER_INFO:
                this.showCustomerInfo = true;
                break;
        }
    }

    private hideAllSteps() {
        this.showProductCountInfo = false;
        this.showCustomerInfo = false;
        this.showCustomerContactInfo = false;
        this.resetEnabled = false;
        this.isValid = false;
    }


    public async onSubmit() {


        if (SalesConciergeStep[this.salesConciergeNextStep] === SalesConciergeStep.SEND_REQUEST) {

            if (SalesConciergeRequestType[this.salesConciergeRequest.requestType] !== SalesConciergeRequestType.OTHER_ISSUES) {
                this.salesConciergeRequest.otherIssuesMessage = null;
            }
            try {
                await this.salesConciergeService.createSalesConciergeRequest(this.salesConciergeRequest);
                this.close();
                try {
                    this.toastService.showSuccessWide('Ihre Anfrage wurde erfolgreich abgesendet');
                } catch (error) {

                }

            } catch (error) {
                const errorMsg = 'SHOW_SALES_CONCIERGE_REQUEST_FAILED_ERROR';
                // tell the iOS device to show a native error message if the request process failed
                this.postIosMessage({
                    action: errorMsg,
                    errorDetails: error
                });
                this.postAndroidMessage(errorMsg);
                this.close();
                try {
                    this.toastService.showWarningWide('Es ist leider ein Fehler aufgetreten. Ihre Anfrage konnte nicht gesendet werden.');
                } catch (error) {

                }

            } finally {
                const success = 'SHOW_SALES_CONCIERGE_REQUEST_SUCCESS_MESSAGE';
                // tell the iOS device to show a native success message if the request process succeeded
                this.postIosMessage({
                    action: success
                });
                this.postAndroidMessage(success);

            }
        } else {
            this.resetEnabled = false;
            this.isValid = false;
            switch (SalesConciergeRequestType[this.salesConciergeRequest.requestType]) {
                case this.salesConciergeRequestType.OTHER_ISSUES:
                    this.hideAllSteps();
                    this.showCustomerContactInfo = true;
                    this.isValid = true;
                    break;
                case this.salesConciergeRequestType.DEALER_CONTRACT_OR_BILLING_ISSUES:
                    this.hideAllSteps();
                    this.showCustomerContactInfo = true;
                    this.isValid = true;
                    break;
                case this.salesConciergeRequestType.NEW_ACQUISITION:
                    this.showProductCountInfo = true;
                    this.resetEnabled = false;
                    this.isValid = true;

                    if (!this.showRequestType && SalesConciergeProductCount[this.salesConciergeRequest.productCountInfo] === SalesConciergeProductCount.MORE_THAN_50) {
                        this.showProductCountInfo = false;
                        this.showCustomerInfo = true;
                        this.isValid = false;

                        if (this.salesConciergeRequest.customerInfo === null || this.salesConciergeRequest.customerInfo === undefined) {
                            this.salesConciergeRequest.customerInfo = new SalesConciergeCustomerInfo();
                            this.salesConciergeRequest.customerInfo.customerType = null;
                            this.salesConciergeRequest.customerInfo.zip = null;
                        }

                        if (SalesConciergeStep[this.salesConciergeNextStep] === SalesConciergeStep.CUSTOMER_CONTACT_INFO) {
                            this.showCustomerContactInfo = true;
                            this.showCustomerInfo = false;
                            this.isValid = true;
                        }
                    }

                    if (!this.showRequestType && SalesConciergeProductCount[this.salesConciergeRequest.productCountInfo] === SalesConciergeProductCount.NO_INFORMATION || SalesConciergeProductCount[this.salesConciergeRequest.productCountInfo] === SalesConciergeProductCount.LESS_THAN_50) {
                        this.hideAllSteps();
                        this.showCustomerContactInfo = true;
                        this.isValid = true;
                    }
                    break;
                case this.salesConciergeRequestType.NO_INFORMATION:
                    this.hideAllSteps();
                    this.showCustomerContactInfo = true;
                    this.isValid = true;
                    break;
                case this.salesConciergeRequestType.TECHNICAL_ISSUE_OR_SUPPORT:
                    this.hideAllSteps();
                    this.showCustomerContactInfo = true;
                    this.isValid = true;
                    break;
            }


            if ((SalesConciergeContactType[this.salesConciergeRequest.contactType] === SalesConciergeContactType.CUSTOM_CONTACT_INFO)
                && (this.salesConciergeRequest.customContactInfo.email === null && this.salesConciergeRequest.customContactInfo.name === null)
            ) {


                this.isValid = false;

            }


            this.showRequestType = false;

        }
    }

    public reset(): void {
        this.isValid = false;
        this.resetEnabled = false;

        if (this.showRequestType && this.salesConciergeRequest !== undefined) {
            this.salesConciergeRequest.requestType = null;
            this.salesConciergeRequest.otherIssuesMessage = null;
        }

        if (this.showCustomerContactInfo) {

            this.salesConciergeRequest.contactType = this.getKeyByValue(SalesConciergeContactType, SalesConciergeContactType.EXISTING_CONTACT_INFO);
            this.salesConciergeRequest.customContactInfo.email = null;
            this.salesConciergeRequest.customContactInfo.phone = null;
            this.salesConciergeRequest.customContactInfo.name = null;
            this.salesConciergeRequest.requestNotes = null;
            this.isValid = true;
        }

        if (this.showCustomerInfo) {
            this.salesConciergeRequest.customerInfo.customerType = null;
            this.salesConciergeRequest.customerInfo.zip = null;
            this.isValid = false;
        }

        if (this.showProductCountInfo) {
            this.salesConciergeRequest.productCountInfo = this.getKeyByValue(SalesConciergeProductCount, SalesConciergeProductCount.NO_INFORMATION);
            this.isValid = true;
        }
    }

}
